import React from 'react';

import AlertIcon from '@hero/ui-kit/icons/utility/AlertIcon';
import Tooltip, { Placement } from '@hero/ui-kit/components/Tooltip';

interface MismatchFlagProps {
    content: React.ReactNode;
    placement?: Placement;
}

// Warning flag shown when a value the member set on the device differs from the form-filled value.
const MismatchFlag: React.FC<MismatchFlagProps> = ({ content, placement = 'top-right' }) => (
    <Tooltip content={content} placement={placement} width="24rem">
        <AlertIcon size="utility" styles={{ display: 'block', cursor: 'help' }} />
    </Tooltip>
);

export default MismatchFlag;
